import React, { useEffect, useState } from 'react';
import { useDebounce } from 'use-debounce';
import { useUnrealizedGainLoss } from '../../../../../../hooks/useUnrealizedGainLoss';
import { GainLossDetailsEmpty } from '../../../GainLossDetailsEmpty/GainLossDetailsEmpty';
import { GainLossDetailsError } from '../../../GainLossDetailsError/GainLossDetailsError';
import { GainLossDetailsLoading } from '../../../GainLossDetailsLoading/GainLossDetailsLoading';
import { UnrealizedGainLossDetailsContent } from './components/UnrealizedGainLossDetailsContent/UnrealizedGainLossDetailsContent';
import { PositionsDTO, TaxLotDetailsDTO } from '../../../GainLossMobile/GainLossMobile.meta';
import { TaxLotMobile } from '../../../GainLossMobile/components/TaxLotMobile';
import { PositionMobile } from '../../../GainLossMobile/components/PositionMobile';

interface Props {
  title: string;
}

export const UnrealizedGainLossDetails = ({ title }: Props) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [positionMobile, setPositionMobile] = useState<PositionsDTO | null>(null);
  const [taxLotsMobile, setTaxLotsMobile] = useState<TaxLotDetailsDTO[] | null>(null);

  const [debouncedSearchTerm] = useDebounce(searchTerm, 200);

  const { data, isFetching, isError, refetch } = useUnrealizedGainLoss();

  useEffect(() => {
    setPositionMobile(null);
    setTaxLotsMobile(null);
  }, [isFetching]);

  if (isFetching) {
    return <GainLossDetailsLoading title={title} />;
  }

  if (isError) {
    return <GainLossDetailsError title={title} onRetry={refetch} />;
  }

  if (!data) {
    return null;
  }

  const { tableData } = data;

  if (!tableData) {
    return null;
  }

  if (tableData.rows.length === 0) {
    return <GainLossDetailsEmpty title={title} />;
  }

  if (taxLotsMobile) {
    return (
      <TaxLotMobile
        type="unrealized"
        taxLots={taxLotsMobile}
        goBack={() => setTaxLotsMobile(null)}
      />
    );
  }

  if (positionMobile) {
    return (
      <PositionMobile
        type="unrealized"
        position={positionMobile}
        goBack={() => setPositionMobile(null)}
        setTaxSlots={setTaxLotsMobile}
      />
    );
  }

  return (
    <UnrealizedGainLossDetailsContent
      data={data}
      debouncedSearchTerm={debouncedSearchTerm}
      title={title}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      setPositionMobile={setPositionMobile}
    />
  );
};
